<template>
  <div class="login_box">
    <div class="login_l">
        <img class="logo" src="@/assets/login/logo.png" alt="" />
      <img class="login_bg" src="@/assets/login/bg.png" alt="" />
    </div>
    <div class="login_r">
      <div class="flex a-l-c fz26">
        <!-- <img class="logo" src="@/assets/login/logo.png" alt="" /> -->
        <!-- <span>江苏金航科技有限公司1111</span> -->
      </div>

      <div class="islogin">
        <!-- 登录 -->
        <hc-login v-if="activeKey === 'login'" @forget="activeKey = 'register'" @forpsd="activeKey = 'forget'" />
        
        <!-- 注册 -->
        <forget
          v-else-if="activeKey === 'register'"
          title="注册"
          :btnType="0"
          @login="activeKey = 'login'"
        />

        <!-- 忘记密码 -->
        <forget
          v-else-if="activeKey === 'forget'"
          title="忘记密码"
          :btnType="1"
          @login="activeKey = 'login'"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import hcLogin from "./components/hc-login.vue";
import forget from "./components/forget.vue";

const activeKey = ref("login");
</script>

<style lang="less" scoped>
.login_box {
  height: 100vh;
  width: 100%;
  overflow: hidden;
  background-color: #fff;
  display: flex;
}

.login_r {
  width: 796px;
  background-color: #fff;
  padding: 20px;
  position: relative;
}

.login_l {
  flex: 1;
}

.login_bg {
  width: 100%;
  height: 100%;
}

.logo {
  width: 250px;
  height: 50px;
  position: absolute;
  left: 20px;
  top: 20px;
}

.islogin {
  margin: 0 auto;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
